<template>
  <v-dialog
    v-model="dialog"
    class="forgot-password__dialog"
    width="500"
  >
    <template v-slot:activator="{ props }"> </template>

    <v-card class="pa-5" v-model="isClose">
      <v-row>
        <v-col cols="3">
          <v-btn icon variant="text" @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="9">
          <v-card-title
            class="d-flex justify-start align-center text-center mb-3"
            >Change Password</v-card-title
          >
        </v-col>
      </v-row>

      <form @submit.prevent="submit" class="login-form">
        <v-text-label class="font-weight-bold">Current Password*</v-text-label>
        <v-text-field
          :type="currentPasswordVisible ? 'text' : 'password'"
          :append-inner-icon="
            currentPasswordVisible ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
          "
          @click:append-inner="passwordVisibility('current')"
          variant="outlined"
          v-model="currentPassword.value.value"
          :error-messages="currentPassword.errorMessage.value"
          placeholder="Current Password"
        ></v-text-field>

        <v-text-label class="font-weight-bold">New Password*</v-text-label>
        <v-text-field
          :type="newPasswordVisible ? 'text' : 'password'"
          :append-inner-icon="
            newPasswordVisible ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
          "
          @click:append-inner="passwordVisibility('new')"
          variant="outlined"
          v-model="newPassword.value.value"
          :error-messages="newPassword.errorMessage.value"
          placeholder="New Password"
        ></v-text-field>

        <v-text-label class="font-weight-bold">Confirm Password*</v-text-label>
        <v-text-field
          :type="confirmPasswordVisible ? 'text' : 'password'"
          :append-inner-icon="
            confirmPasswordVisible ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
          "
          @click:append-inner="passwordVisibility('confirm')"
          variant="outlined"
          v-model="confirmPassword.value.value"
          :error-messages="confirmPassword.errorMessage.value"
          placeholder="Confirm Password"
        ></v-text-field>

        <div class="d-flex align-center text-center justify-center mt-3 mb-3">
          <v-btn type="submit" class="bg-theme-primary" elevation="0">
            Submit
          </v-btn>

          <v-btn elevation="0" @click="dialog = false"> close </v-btn>
        </div>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
  import app from './index.js';

  export default app;
</script>
